"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementTransition = void 0;
var styled_components_1 = require("styled-components");
function elementTransition(params) {
    var attrs = params.attrs, _a = params.duration, duration = _a === void 0 ? 0.5 : _a, _b = params.type, type = _b === void 0 ? 'ease-out' : _b;
    var attributes = typeof attrs === 'string' ? [attrs] : attrs;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition: ", ";\n  "], ["\n    transition: ", ";\n  "])), attributes
        .map(function (attribute) {
        return "".concat(attribute, " ").concat(duration, "s ").concat(type);
    })
        .join(', '));
}
exports.elementTransition = elementTransition;
var templateObject_1;
